import { WorkspaceButton } from './WorkspaceButton';

export default WorkspaceButton;

export { WorkspaceButton };
